import React from "react";
import { GraduationCap, MapPin, BookOpen } from "lucide-react";
import { education } from "../data/mock";

const Education = () => {
  return (
    <section id="education" className="relative py-24 lg:py-32 border-t border-teal-500/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-teal-400 mb-4">
            <span className="w-8 h-px bg-teal-400" /> 03 — Education
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-bold leading-tight">
            Where I <span className="text-teal-300">learned the fundamentals</span>.
          </h2>
        </div>

        <div className="relative pl-6 sm:pl-10">
          <div className="absolute left-2 sm:left-4 top-2 bottom-2 w-px bg-gradient-to-b from-teal-400 via-teal-500/40 to-transparent" />

          <div className="space-y-10">
            {education.map((e) => (
              <div key={e.id} className="relative group">
                <div className="absolute -left-[26px] sm:-left-[34px] top-7 w-4 h-4 rounded-full bg-[#04100f] border-2 border-teal-400 flex items-center justify-center">
                  <div className="w-1.5 h-1.5 rounded-full bg-teal-400 group-hover:scale-150 transition-transform" />
                </div>
                <div className="rounded-2xl border border-teal-500/15 bg-[#08201d]/60 p-7 hover:border-teal-400/40 transition-colors">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 rounded-xl border border-teal-500/20 bg-[#04100f]/60 flex items-center justify-center shrink-0 overflow-hidden">
                      {e.logo
                        ? <img src={e.logo} alt={e.institution} className="w-full h-full object-cover" />
                        : <GraduationCap className="w-7 h-7 text-teal-500/40" />
                      }
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-wrap items-start justify-between gap-3">
                        <div>
                          <div className="flex items-center gap-2 text-teal-300">
                            <GraduationCap className="w-4 h-4" />
                            <span className="text-sm font-mono">{e.institution}</span>
                          </div>
                          <h3 className="font-display text-xl sm:text-2xl font-semibold mt-1 text-slate-100">
                            {e.degree}
                          </h3>
                        </div>
                        <div className="text-right">
                          <div className="text-sm text-slate-200 font-medium">{e.period}</div>
                          <div className="text-xs text-slate-400 mt-0.5 flex items-center justify-end gap-1">
                            <MapPin className="w-3 h-3" />
                            {e.location}
                          </div>
                        </div>
                      </div>

                      {e.gpa && (
                        <div className="mt-5 flex items-center gap-2 text-sm text-slate-300">
                          <BookOpen className="w-4 h-4 text-teal-400 shrink-0" />
                          <span>GPA: <span className="text-teal-300 font-medium">{e.gpa}</span></span>
                        </div>
                      )}

                      {e.bullets && e.bullets.length > 0 && (
                        <ul className="mt-5 space-y-2.5">
                          {e.bullets.map((b, i) => (
                            <li key={i} className="flex items-baseline gap-3 text-sm text-slate-300 leading-relaxed">
                              <span className="text-teal-400 shrink-0">▪</span>
                              <span>{b}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
